import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { GoogleAuthService } from './google-auth-service';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const googleAuth = inject(GoogleAuthService);

  const devHeaders = googleAuth.getDevAuthHeaders();
  if (devHeaders) {
    return next(req.clone({ setHeaders: devHeaders }));
  }

  return from(auth.authStateReady()).pipe(
    switchMap(() => {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        return next(req);
      }

      return from(currentUser.getIdToken()).pipe(
        switchMap(token => {
          if (!token) {
            return next(req);
          }

          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });

          return next(authReq);
        })
      );
    })
  );
};
